module.exports = __webpack_public_path__ + "5ce9e18b81d88e9ab139ec97053720f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth0Animation/components/Step5/step-5-placeholder.png
// module id = 1557
// module chunks = 0